import { render, staticRenderFns } from "./InformasiBongkarUpload.vue?vue&type=template&id=6147da29&scoped=true"
import script from "./InformasiBongkarUpload.vue?vue&type=script&lang=js"
export * from "./InformasiBongkarUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6147da29",
  null
  
)

export default component.exports